import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoCliente } from '../../servicos/srv.cliente';

@Component({
  selector: 'tsv2-cli-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoCliente, ServicoMsg ]
})
export class ClienteListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;
  @Input() tipoCaptura: number;

  @Output() trocar = new EventEmitter();

  constructor(
    private servicoMsg: ServicoMsg,
    private servicoCliente: ServicoCliente
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerCliente(id){
    let titulo = 'Remover o cliente?';
    let texto = 'Cliente removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoCliente, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
